﻿import { Components } from 'formiojs';
import './autocomplete.min.css';

// If autocomplete library has no types, declare it as any
import autocomplete from './autocomplete.wrapper.min';

interface SuggestionItem {
  label: string;
  [key: string]: any;
}

class AutocompleteComponent extends (Components.components.textfield as any) {
  static schema(...extend: any[]): any {
    return super.schema(
      {
        label: 'AutoComplete',
        key: 'autocomplete',
        type: 'autocomplete',
        input: true,
      },
      ...extend
    );
  }

  static get builderInfo() {
    return {
      title: 'AutoComplete',
      group: 'basic',
      icon: 'search',
      weight: 72,
      documentation: '#',
      schema: this.schema(),
    };
  }

  attach(element: HTMLElement): any {
    super.attach(element);

    if (this.refs?.input && this.refs.input.length > 0) {
      const input: HTMLInputElement = this.refs.input[0];
      const $self = this as any;

      let suggestions: SuggestionItem[] | null = null;

      autocomplete.default({
        input,
        minLength: 0,
        emptyMsg: 'No items found',
        preventSubmit: true,
        showOnFocus: true,
        className: 'formio-autocomplete-custom',

        async fetch(text: string, update: (items: SuggestionItem[]) => void) {
          let availableSuggestions: SuggestionItem[] | undefined;

          if (!suggestions) {
            try {
              const response = await fetch(
                `${$self.component.suggestions_url}?componentKey=${$self.component.key}`
              );

              if (response.ok) {
                suggestions = await response.json();
                availableSuggestions = suggestions?.filter((n) => n.label.toLowerCase()
                            .indexOf(text.toLowerCase()) > -1);
              }
            } catch (err) {
              console.error(err);
            }
          } else {
            availableSuggestions = suggestions?.filter((n) =>
              n.label.toLowerCase().includes(text.toLowerCase())
            );
          }

          if (!availableSuggestions || availableSuggestions.length === 0) {
            availableSuggestions = suggestions ?? [];
          }

          update(availableSuggestions);
        },

        onSelect(item: SuggestionItem) {
          const flags = {
            noValidate: true,
            noCheck: true,
            resetValue: true,
          };

          $self.setValueAt(0, item.label, flags);
          $self.dataValue = item.label;

          $self.triggerChange({
            modified: true,
          });
        },
      });
    }
  }

  static editForm(a: any, b: any, c: any) {
    const form = Components.components.textfield.editForm(a, b, c);

    const tabs = form?.components?.find((obj: any) => obj.type === 'tabs');
    const datatab = tabs?.components?.find((obj: any) => obj.key === 'data');

    // remove "multiple" option
    const index = datatab.components.findIndex((obj: any) => obj.key === 'multiple');
    if (index > -1) datatab.components.splice(index, 1);

    // Insert suggestions_url input
    datatab.components.splice(1, 0, {
      input: true,
      key: 'suggestions_url',
      label: 'Suggestions URL',
      placeholder: 'Suggestions URL',
      tooltip: 'This is the url from where we retrieve the autocomplete suggestions',
      type: 'textfield',
      validate: {
        required: true,
      },
    });

    return form;
  }
}

// Register component
(Components as any).addComponent('AutocompleteComponent', AutocompleteComponent);

export default AutocompleteComponent;
